export const EMPTY_LICENSE_PLATE = '__-__ ___';
export const EMPTY_LICENSE_PLATE_SELECT_OPTION = {licensePlate: EMPTY_LICENSE_PLATE, value: EMPTY_LICENSE_PLATE, id: 0};
